import React from 'react';

import Text from 'components/Text/Text';
import { QuoteVariant } from 'utils/sharedStrapiQueries/sharedTypes';
import { validFontCategories } from 'utils/styles/theme';

import * as S from './Quote.styles';

const QUOTE_VARIANTS: {
  [variant in QuoteVariant]: typeof validFontCategories[number];
} = {
  large: 'heading2',
  small: 'heading5',
};

const QUOTE_DESCRIPTION_VARIANTS: {
  [variant in QuoteVariant]: typeof validFontCategories[number];
} = {
  large: 'body',
  small: 'small',
};

export interface QuoteProps {
  quote: string;
  quoteAuthor?: string;
  quoteDescription?: string;
  quoteVariant: QuoteVariant;
}

const Quote: React.FunctionComponent<QuoteProps> = ({
  quote,
  quoteAuthor,
  quoteDescription,
  quoteVariant = 'small',
}) => {
  return (
    <S.QuoteWrapper>
      <Text text={quote} size={QUOTE_VARIANTS[quoteVariant]} as="blockquote" />

      <S.QuoteDescription>
        {quoteAuthor && (
          <Text
            text={quoteAuthor}
            size={QUOTE_DESCRIPTION_VARIANTS[quoteVariant]}
          />
        )}
        {quoteDescription && (
          <Text
            text={quoteDescription}
            size={QUOTE_DESCRIPTION_VARIANTS[quoteVariant]}
          />
        )}
      </S.QuoteDescription>
    </S.QuoteWrapper>
  );
};

export default Quote;
